<template>
    <l-map
        style="height: 60vh; width: 100%; z-index: 0"
        :zoom.sync="zoom"
        :center.sync="center"
        :bounds.sync="bounds"
        :options="{
            zoomControl: false,
            doubleClickZoom: false,
            dragging: false,
            scrollWheelZoom: false,
            touchZoom: false
        }"
    >
        <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
        <l-marker :lat-lng="marker" ref="marker">
            <l-popup
                :options="{
                    closeButton: false,
                    closeOnEscapeKey: false,
                    closeOnClick: false,
                    minWidth: 270,
                }"
            >
                <v-row align="center">
                    <v-col cols="auto">
                        <v-img src="@/assets/logo.png" width="50"></v-img>
                    </v-col>
                    <v-col>
                        <div class="text-h5 font-weight-black">UTC-SYSTEM</div>
                    </v-col>
                </v-row>
                <v-row align="center" class="mt-1">
                    <v-col cols="auto">
                        <v-icon>mdi-map-marker</v-icon>
                    </v-col>
                    <v-col>
                        <div class="text-subtitle-2 text-capitalize font-weight-black">45 allée théodore monod</div>
                        <div class="text-subtitle-2 text-uppercase font-weight-black">64210 bidart</div>
                        <div class="text-subtitle-2 text-uppercase font-weight-black">france</div>
                    </v-col>
                </v-row>
                <v-row align="center" class="mt-1">
                    <v-col cols="auto">
                        <v-icon>mdi-phone</v-icon>
                    </v-col>
                    <v-col>
                        <div class="text-subtitle-2 font-weight-black">(+33)5 59 43 84 81</div>
                    </v-col>
                </v-row>
                <v-row align="center" class="mt-1">
                    <v-col cols="auto">
                        <v-icon>mdi-at</v-icon>
                    </v-col>
                    <v-col>
                        <div class="text-subtitle-2 font-weight-black">{{technicalSupportAddress}}</div>
                    </v-col>
                </v-row>
            </l-popup>
        </l-marker>
    </l-map>
</template>
<script>
import { Icon, latLng } from 'leaflet';
import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
    name: "Map",
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup
    },
     props: {
        technicalSupportAddress: String,
    },
    data() {
        return {
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            zoom: 3,
            center: latLng(50, -1.5531544934050936),
            marker: latLng(43.446758229049244, -1.5531544934050936),
            bounds: null,
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs.marker.mapObject.openPopup()
        }) 
    },
}
</script>